import { createRouter, createWebHistory } from "vue-router";
import Start from "@/views/start/index.vue"; // 引导页
import Home from "@/views/home/index.vue"; // 首页
import Exhibitor from "@/views/exhibitor/index.vue"; // 展会入口
import Media from "@/views/media/index.vue"; // 媒体入口
import Audience from "@/views/audience/index.vue"; // 观众入口
import News  from "@/views/news/index.vue"; // 新闻中心->新闻
import Video  from "@/views/news/index.vue"; // 新闻中心->视频
import Images  from "@/views/news/index.vue"; // 新闻中心->图片
import Contact from "@/views/contact/index.vue"; // 联系我们
import Article from "@/views/article/index.vue"; // 文章详情
import Sale from "@/views/sale/index.vue"; // 销售入口


// 定义路由规则
const routes = [
   {
    path: '/',
    redirect: '/start'
  },
  {
    path: '/start',
    name: "start",
    component: Start,
  },
  {
    path: "/home",
    name: "home",
    component: Home,
  },
  {
    path: "/exhibitor",
    name: "exhibitor",
    component: Exhibitor
  },
  {
    path: "/media",
    name: "media",
    component: Media
  },
  {
    path: "/audience",
    name: "audience",
    component: Audience
  },
  {
    path: "/video",
    name: "video",
    component:  Video,
  },
  {
    path: "/images",
    name: "images",
    component:  Images,
  },
  {
    path: "/news",
    name: "news",
    component:  News,
  },
  {
    path: "/contact",
    name: "contact",
    component:Contact,
  },
  {
    path: "/article/:id",
    name: "article",
    component: Article,
  },
  {
    path: "/sale",
    name: "sale",
    component: Sale,
  },
];

// 创建路由实例
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior: async (to, from, savedPosition) => {
    // 给点延迟保证dom加载完成
    await new Promise((resolve) => {setTimeout(resolve, 5e2)})
    if (to.hash) {
      // 处理url中的锚点链接，滚动到对应的位置
      let target = document.querySelector(`a[href="${to.hash}"]`);
      if (target) {
        return {
          el: target,
          behavior: 'smooth'
        }
      }
      return savedPosition || { top: 0 };
    }
    return savedPosition || { top: 0 };
  }
});

router.afterEach(async (to, from) => {
  setTimeout(() => {
    // 处理锚点链接点击事件为不打开新标签
    document.querySelectorAll('a[href^="#"]').forEach((item) => {
      if (item.getAttribute('target') !== '_self') {
        item.setAttribute('target', '_self');
      }
    });
  }, 1e3)
});
export default router;